import React from "react";
import CoBorrowerList from "@/modules/client/loan-application/features/loan-origination/sub-features/additional-details/components/co-borrower-list";
import ReferrerSection from "@/modules/client/loan-application/features/loan-origination/sub-features/additional-details/components/referrer-section";

/**
 * AdditionalDetailsStep — Step 3: co-borrowers list + referrer details.
 */
export default function AdditionalDetailsStep() {
  return (
    <div className="space-y-8">
      <CoBorrowerList />
      <div className="border-t border-gray-200 pt-6 dark:border-slate-700">
        <ReferrerSection />
      </div>
    </div>
  );
}

